#import "./ParashahDetails.graphql"
query ParshiyotQuery {
  parshiyot {
    ...parashahDetails
  }
}
